const toggleElement = (element: HTMLElement) => {
    const currentState = element.getAttribute('aria-expanded') === 'true';
    const newState = !currentState;
    
    element.setAttribute('aria-expanded', newState.toString());
    element.classList.toggle('is-active');
    const elementToToggle = document.getElementById(element.dataset.togglewhat as string);

    if (elementToToggle) {
        elementToToggle.classList.toggle('is-active');
        elementToToggle.querySelectorAll<HTMLElement>('button, input, a').forEach(el => {
            el.setAttribute('tabindex', `${newState ? '0' : '-1'}`);
        });

        if (newState) {
            elementToToggle.focus();
        }

        elementToToggle.dispatchEvent(
            new CustomEvent('elementToggled')
        );
    }

    //Ugly edgecases, but the modals rely on stackcontext being the same as the headers. Remove sticky from productdetails when modals open, add it when closing. 
    //Find a better solution for this later, this is a quick fix.
    if(element.dataset.togglewhat === 'storeInventory') {
        document.getElementById('product-details')?.classList.toggle('sticky');
    }
    if(element.dataset.togglewhat === 'sizeguide') {
        document.getElementById('product-details')?.classList.toggle('sticky');
    }
    if(element.dataset.togglewhat === 'inventoryNotification') {
        document.getElementById('product-details')?.classList.toggle('sticky');
    }
};

// Track which elements have been initialized to prevent duplicate listeners
const initializedTogglers = new WeakSet<HTMLElement>();

const toggler = () => {
    document.querySelectorAll<HTMLElement>('._js-generic-toggler').forEach(trigger => {
        if (initializedTogglers.has(trigger)) {
            return;
        }

        const controlsWhat = trigger.dataset.togglewhat as string;

        trigger.setAttribute('aria-controls', controlsWhat);
        trigger.setAttribute('aria-expanded', 'false');

        // Remove tabindex on hidden content controlled by trigger
        const controlsElement = document.getElementById(controlsWhat);
        if (controlsElement) {
            controlsElement.querySelectorAll<HTMLElement>('button, input, a').forEach(el => {
                el.setAttribute('tabindex', '-1');
            });
        }

        trigger.addEventListener('click', (e: Event) => {
            if ((e.currentTarget as HTMLElement).nodeName !== 'INPUT') {
                e.preventDefault();
            }
            //Use currentTarget to find the the element that fired the event.
            //If there is a button with an svg inside e.target could be the svg,
            //we want the button element
            toggleElement(e.currentTarget as HTMLElement);
        });

        initializedTogglers.add(trigger);
    });

    //Needs to use triggerNested if elemtn is inside another toggler
    document.querySelectorAll<HTMLElement>('._js-generic-toggler-nested').forEach(el => {
        if (initializedTogglers.has(el)) {
            return;
        }

        const controlsWhat = el.dataset.togglewhat as string;
        el.setAttribute('aria-controls', controlsWhat);
        el.setAttribute('aria-expanded', 'false');
        
        el.addEventListener('click', (e: Event) => {
            e.preventDefault();
            //Use currentTarget to find the the element that fired the event.
            //If there is a button with an svg inside e.target could be the svg,
            //we want the button element
            toggleElement(e.currentTarget as HTMLElement);
        });

        initializedTogglers.add(el);
    });
};

export const vueComponentToggler = () => {
    document.querySelectorAll<HTMLElement>('._js-vue-component-toggler').forEach(trigger => {
        if (initializedTogglers.has(trigger)) {
            return;
        }

        const controlsWhat = trigger.dataset.togglewhat as string;

        trigger.setAttribute('aria-controls', controlsWhat);
        trigger.setAttribute('aria-expanded', 'false');

        // Remove tabindex on hidden content controlled by trigger
        const controlsElement = document.getElementById(controlsWhat);
        if (controlsElement) {
            controlsElement.querySelectorAll<HTMLElement>('button, input, a').forEach(el => {
                el.setAttribute('tabindex', '-1');
            });
        }

        trigger.addEventListener('click', e => {
            if (trigger.nodeName !== 'INPUT') {
                e.preventDefault();
            }
            //Use currentTarget to find the the element that fired the event.
            //If there is a button with an svg inside e.target could be the svg,
            //we want the button element
            toggleElement(e.currentTarget as HTMLElement);
        });

        initializedTogglers.add(trigger);
    });
};

export const initToggle = () => {
    toggler();
};

export const closeOpenElement = (element: HTMLElement): void => {
    // Check if already closed to avoid double-toggling
    if (element.getAttribute('aria-expanded') === 'false') {
        return;
    }
    toggleElement(element);
};
